import MiniInput from './MiniInput';
export default MiniInput;
